<template>
  <div>
    <el-dropdown @command="handleCommand($event)" v-loading="printOrderLoading">
      <el-button class="btn-secondary px-1" style="width: 40px;">
        <i class="far fa-file-alt"></i>
        <i class="el-icon-arrow-down el-icon--right fa-sm"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="oc">Order Confirmation</el-dropdown-item>
        <el-dropdown-item command="inv"
          v-if="initial_purchase.invoice_collections && initial_purchase.invoice_collections.length > 0">Invoice</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import OrderConfirmation from "../../../modelsPortal/OrderConfirmation";
import Purchase from "../../../modelsPortal/Purchase";
export default {
  props: {
    initial_purchase: {
      type: Object
    },
  },
  mounted() {

  },
  data() {
    return {
      date_of_issue: moment().format('YYYY-MM-DD'),
      printOrderLoading: false,
      user_id: null,
    };
  },
  methods: {
    handleCommand(event) {
      if (event == 'oc') {
        this.printOrderConfirmation();
      }
      if (event == 'inv') {
        this.downloadDocument();
      }
    },
    downloadDocument() {
      let media = this.initial_purchase.invoice_collections;
      if (media[0]) {
        var anchor = document.createElement('a');
        anchor.href = media[0].url;
        anchor.target = '_blank';
        anchor.download = media[0].file_name;
        anchor.click();
      }
    },
    async printOrderConfirmation() {
      if (this.initial_purchase.order_confirmation_url)
        window.open(this.initial_purchase.order_confirmation_url, "_blank"); // open
    }
  },
};
</script>
